import React, { Component } from "react";

const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

class RadioControlsForMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        }
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }
    componentDidMount()
    {
        this.setState({
            selectedOption: this.props.radioKeys[0],
            loaded: true
        });
        // console.log("comp mounted");
    }
    handleOptionChange = changeEvent => {
        // console.log(changeEvent.target.value);
        this.setState({
            selectedOption: changeEvent.target.value
        });
        this.props.handleChange(changeEvent.target.value);
    };
    render() {
        if (this.state.loaded){
        if (this.props.radioKeysPreset) {
            return (
                <form>
                    <p className="lead">{this.props.textAboveMapControls}</p>
                    {this.props.radioKeys.map((x, i) => <div key={`map-radio-${i}`} className="form-check">
                        <input styles={{ textTransform: "capitalize" }} onChange={this.handleOptionChange} className="form-check-input map-radio" type="radio" name="inlineRadioOptions" id={x} value={x} checked={this.state.selectedOption === x} />
                        <label className="form-check-label" htmlFor={x}>{this.props.radioKeysPreset[x]}</label>
                    </div>)}
                </form>
            );
        }
        else {
            return (
                <form>
                    <p className="lead">{this.props.textAboveMapControls}</p>
                    {this.props.radioKeys.map((x, i) => <div key={`map-radio-${i}`} className="form-check">
                        <input styles={{ textTransform: "capitalize" }} onChange={this.handleOptionChange} className="form-check-input map-radio" type="radio" name="inlineRadioOptions" id={x} value={x} checked={this.state.selectedOption === x} />
                        <label className="form-check-label" htmlFor={x}>{toTitleCase(x.replace(/_/g, " "))}</label>
                    </div>)}
                </form>
            );
        }
    }
    else{
        return null;
    }
    }
}

export default RadioControlsForMap;